const news = {
    getHistoryKeyword: { api: '/api.php/Search/getHistoryKeyword', },
    getSearchLists: { api: '/api.php/Search/getSearchLists', },
    getSearchResultInfo: { api: '/api.php/Search/getSearchResultInfo', },
    checkSearchKeyword: { api: '/api.php/Search/checkSearchKeyword', },
}
export default news
